.preview-changes-drawer {
  --mds-drawer-container-width: 768px !important;
  --mds-activity-timeline-item-content-time-padding-bottom: 0 !important;
  --mds-activity-timeline-item-content-time-padding-top: 0;
 .on-click-outside-container{
   display:flex;
   flex-direction: column;
   height: 100%;
 }
}

.preview-changes-title {
  padding: 16px 0;
}

.search-box {
  padding: 12px 0;
}
.preview-changes {
  padding-top: 12px;

  .mds-activity-timeline-item-section {
    .mds-activity-timeline-item-content-time {
      padding: 0;
      display: none;
    }
  }

  .mds-activity-timeline-item-content-children {
    width: 100%;

    .transaction-title {
      padding: 2px 8px;
      color: var(--base-text-strong-default);
      border-radius: 6px;
    }
  }

  .transaction-event-list {
    gap: 2px;
    padding: 4px 0 0 16px;

    .transaction-event {
      &:first-letter {
        text-transform: capitalize;
      }
      color: var(--base-text-medium-default);

      display: list-item;
      list-style-type: disc;
      line-height: 18px;
    }
  }


}